{
  "primary": {
    "type": "primary",
    "field": "primary_color",
    "hex_default": "#5c29d3",
    "rgb_default": "rgb(92, 41, 211)",
    "hex_css_val": "--primary-brand-color-hex",
    "rgb_css_val": "--primary-brand-color-rgb-vals",
    "text_hex_css_val": "--text-primary-color-hex"
  },
  "secondary": {
    "type": "secondary",
    "field": "secondary_color",
    "hex_default": "#dde3e9",
    "rgb_default": "rgb(221, 227, 233)",
    "hex_css_val": "--secondary-brand-color-hex",
    "rgb_css_val": "--secondary-brand-color-rgb-vals",
    "text_hex_css_val": "--text-secondary-color-hex"
  },
  "secondary_2": {
    "type": "secondary_2",
    "field": "secondary_2_color",
    "hex_default": "#fff",
    "rgb_default": "rgb(255, 255, 255)",
    "hex_css_val": "--secondary-2-brand-color-hex",
    "rgb_css_val": "--secondary-2-brand-color-rgb-vals",
    "text_hex_css_val": "--text-secondary-2-color-hex"
  },
  "secondary_3": {
    "type": "secondary_3",
    "field": "secondary_3_color",
    "hex_default": "#fff",
    "rgb_default": "rgb(255, 255, 255)",
    "hex_css_val": "--secondary-3-brand-color-hex",
    "rgb_css_val": "--secondary-3-brand-color-rgb-vals",
    "text_hex_css_val": "--text-secondary-3-color-hex"
  },
  "dark": {
    "type": "dark",
    "field": "dark_color",
    "hex_default": "#000000",
    "rgb_default": "rgb(0, 0, 0)",
    "hex_css_val": "--dark-brand-color-hex",
    "rgb_css_val": "--dark-brand-color-rgb-vals",
    "text_hex_css_val": "--text-dark-color-hex"
  },
  "light": {
    "type": "light",
    "field": "light_color",
    "hex_default": "#f7f8f9",
    "rgb_default": "rgb(247, 248, 249)",
    "hex_css_val": "--light-brand-color-hex",
    "rgb_css_val": "--light-brand-color-rgb-vals",
    "text_hex_css_val": "--text-light-color-hex"
  }
}
